import ScrollCarousel from '../../components/ScrollCarousel';

export const SELECTORS = {
  viewport: '[data-hero-dual-image-carousel-viewport]',
  track: '[data-hero-dual-image-carousel-track]',
};

/**
 * The left/right background-image strips behind the hero content. They carry no
 * controls of their own and are driven entirely by the content carousel — see
 * `HeroDualImage.updateImageSlides`.
 */
export default (el) => {
  if (!el) return null;

  return new ScrollCarousel(el, {
    selectors: SELECTORS,
    initialIndex: 0,
    prevNextButtons: false,
    pageDots: false,
    // Flickity `wrapAround: true`.
    loop: true,
    adaptiveHeight: true,
    draggable: false,
    slidesPerView: 1,
    // Decorative: the content carousel is the labelled, announced region.
    role: false,
    ariaLive: false,
  });
};
